module.exports = __webpack_public_path__ + "img/img_wucaipin.87d5c809.png";